import { htmlSafe } from '@ember/template';
import Component from '@glimmer/component';

interface ComponentArgs {
  percent: number;
  backgroundClass: string; // 'bg-success', 'bg-brand', etc
}

export default class ProgressBarComponent extends Component<ComponentArgs> {
  get progressBarStyle() {
    return htmlSafe(`width: ${this.args.percent}%`);
  }
}
